import React, {Component} from 'react';
import styled from 'styled-components';
import {withRouter} from 'react-router-dom';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';
import {getResolvedShortLink} from '../utils/apiHandlers';
import {getImageByAgent} from '../config/agent';

const MobileBackground = getImageByAgent('mobileBackground.png');
const companyLogo = getImageByAgent('companyLogo.svg');

class GotoPage extends Component {
  state = {
    isResolvedShortLink: false,
    isResolvedShortLinkError: false,
  };

  resolveShortLink(token) {
    if (token) {
      getResolvedShortLink(
        token,
      ).then(resp => {
        this.setState({isResolvedShortLink: true});
        if (!resp.success) {
          this.setState({isResolvedShortLinkError: true});
        } else {
          window.location.href = resp.data.link;
        }
      });
    } else {
      this.setState({
        isResolvedShortLink: true,
        isResolvedShortLinkError: true,
      });
    }
  }

  componentDidMount() {
    const token = new URLSearchParams(window.location.search).get('token');
    this.resolveShortLink(token);
  }

  render() {
    return (
      this.state.isResolvedShortLink ?
        <Container background={MobileBackground}>
          <div className='inner'>
            <div className='logo-wrapper'>
              <img width='200px' src={companyLogo} alt='wobi logo'/>
            </div>
            {this.state.isResolvedShortLinkError ? (
              <FormattedMessage tagName='div' id='goto_page.short_link_resolved_error_message'/>) :
              (<div>
                <FormattedMessage tagName='div' id='goto_page.short_link_resolved'/>
              </div>
              )
            }
          </div>
        </Container> : <Container background={MobileBackground} />
    );
  }
}

GotoPage.propTypes = {
  history: PropTypes.object,
  location: PropTypes.object,
  match: PropTypes.object,
};

const Container = styled.div`
  padding: 20px;
  overflow: hidden;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  
  background-image: url(${props => props.background});
  .inner {
    color: #046994;
    text-align: center;
  }
  .logo-wrapper {
    margin-bottom: 30px;
  }
  .check-icon {
    color: #f6921e;
    font-size: 40px;
    margin-bottom: 30px;
    border: 1px solid #f6921e;
    padding: 10px;
    border-radius: 50px;
    background-color: #fff;
  }
`;

export default withRouter(GotoPage);
